import { combineReducers } from "redux";
import event from "./next-event/Next-event.ducks";
import team from "./creche-team/Creche-team.ducks";

export default combineReducers({
  dataEvent: event,
  dataTeam: team,
});
